module.exports = new __parcel__URL__("Design Sprint.b98d94bb.svg").toString();